var _style, _g, _defs, _path, _defs2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBeans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF9062;}\n\t.st1{fill:#F6F1ED;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M88.54,93.06c-1.68-0.04-5.27-0.23-9.64-1.31c-4.65-1.15-6.98-1.73-9.34-3.5c-1.1-0.82-4.4-3.38-5.69-8.03 c-1.65-5.91,1.17-10.82,1.75-11.83c2.77-4.83,7.23-6.73,9.93-7.88c2.84-1.21,5.04-1.53,8.61-2.04c6.22-0.9,11.11-0.55,14.45-0.29 c2.33,0.18,6.03,0.48,10.8,1.61c5.84,1.38,9.98,3.22,11.24,3.8c2.86,1.31,5.4,2.49,8.32,4.82c1.88,1.5,4.29,3.46,6.13,6.86 c1.33,2.46,1.77,4.59,1.9,5.26c0.16,0.87,0.48,2.93,0.15,5.55c-0.23,1.77-0.53,4.16-2.19,6.57c-1.8,2.62-4.19,3.79-5.69,4.53 c-0.92,0.45-3.31,1.53-6.57,1.75c-1.8,0.13-3.06-0.07-5.4-0.44c-3.27-0.52-4.74-1.05-9.78-2.34c-3.36-0.85-5.75-1.39-6.72-1.61 c-4.78-1.06-7.02-1.38-9.49-1.46C89.87,93.01,90.1,93.1,88.54,93.06z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#EDE4D9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.84,71.6c0,0,20.37,0.58,33.29,3.21c4.21,0.86,8.42,1.81,12.54,3.04c1.06,0.32,2.11,0.65,3.15,1.02 c0.48,0.17,1.05,0.5,1.54,0.51c0.61-4.78-5.34-7.45-8.82-9.04c-6.15-2.83-12.81-4.55-19.57-5.01c-3.41-0.23-6.85-0.14-10.25,0.29 c-3.25,0.41-6.84,0.7-9.81,2.14C76.4,68.5,75.23,69.82,75.84,71.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M92.1,139.1c-1.54-0.67-4.8-2.2-8.44-4.84c-3.88-2.82-5.82-4.22-7.34-6.76c-0.71-1.18-2.81-4.79-2.26-9.58 c0.7-6.1,5.15-9.58,6.07-10.3c4.38-3.43,9.23-3.52,12.16-3.57c3.08-0.06,5.25,0.48,8.75,1.34c6.11,1.51,10.5,3.67,13.5,5.16 c2.09,1.04,5.41,2.71,9.41,5.55c4.89,3.47,8.04,6.73,8.99,7.74c2.16,2.29,4.07,4.34,5.9,7.59c1.18,2.1,2.68,4.82,3.1,8.66 c0.31,2.78-0.08,4.92-0.22,5.58c-0.18,0.87-0.65,2.9-1.95,5.2c-0.87,1.55-2.06,3.65-4.5,5.26c-2.66,1.75-5.3,1.94-6.98,2.05 c-1.02,0.07-3.64,0.17-6.75-0.85c-1.72-0.56-2.81-1.21-4.84-2.44c-2.83-1.71-3.99-2.76-8.19-5.84c-2.79-2.06-4.8-3.45-5.62-4.01 c-4.03-2.78-5.98-3.91-8.25-4.92C93.35,139.55,93.53,139.72,92.1,139.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#EDE4D9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.4,114.44c0,0,18.65,8.2,29.64,15.49c3.58,2.38,7.12,4.84,10.48,7.53c0.86,0.69,1.71,1.39,2.53,2.13 c0.38,0.34,0.78,0.86,1.23,1.05c2.36-4.2-2.15-8.91-4.77-11.69c-4.64-4.93-10.16-9.03-16.25-12c-3.08-1.5-6.3-2.7-9.6-3.58 c-3.16-0.84-6.6-1.92-9.9-1.71C90.08,111.77,88.5,112.56,88.4,114.44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBeans);
export default __webpack_public_path__ + "static/media/White_beans.4bac85906c5e7cb58a7e1fd38632bc36.svg";
export { ForwardRef as ReactComponent };